import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-family',
  templateUrl: './item-family.component.html',
  styleUrls: []
})
export class ItemFamiliaComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/familia/item-family.component.ts